var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-vertical full-height big-spacer related-files"},_vm._l((_vm.files),function(file){return _c('div',{key:file.path,staticClass:"spacer"},[_c('alert-log-file',{attrs:{"file":file,"related":_vm.related}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }